// import Reveal from 'reveal.js'
// import '@/node_modules/reveal.js/dist/reveal.css'
// import '@/node_modules/reveal.js/dist/theme/black.css'

let deck

const PresentationElements = document.querySelectorAll('.Presentation')
const PresentationThemeSwitch = document.querySelector(
  '.Presentation-themeSwitch',
)
const PresentationPathElement = document.querySelector('.Presentation-path')
const PresentationReferenceLinkElement = document.querySelector(
  '.Presentation-referenceLink',
)
let idleTimeout
const idleTime = 3000

const PresentationLoadingScreenElement = document.querySelector(
  '.Presentation-loadingScreen',
)
const PresentationSlidesElement = document.querySelector('.Presentation-slides')

window.addEventListener('load', function () {
  PresentationLoadingScreenElement.style.transition = 'opacity 0.5s ease-out'
  PresentationLoadingScreenElement.style.opacity = '0'
  PresentationSlidesElement.style.opacity = '1'
  setTimeout(() => PresentationLoadingScreenElement.remove(), 500)
})

function addPresentationActiveClass(el) {
  el.classList.remove('Presentation--idle')
  clearTimeout(idleTimeout)

  idleTimeout = setTimeout(() => {
    el.classList.add('Presentation--idle')
  }, idleTime)
}

function presentationSlideInit(event) {
  const videoPlayers = document.querySelectorAll('.Presentation video')

  if (videoPlayers) {
    Array.prototype.forEach.call(videoPlayers, function (videoPlayerElement) {
      videoPlayerElement.pause()
      videoPlayerElement.currentTime = 0
    })
  }

  if (event.currentSlide?.getAttribute('data-url') != undefined) {
    PresentationPathElement.innerHTML =
      event.currentSlide.getAttribute('data-url')

    PresentationReferenceLinkElement.href =
      event.currentSlide.getAttribute('data-url')
  }

  if (event.currentSlide?.querySelector('.Model3d') != undefined) {
    window.loadModel(event.currentSlide.querySelector('.Model3d'))
  }

  const model3dItems = document.querySelectorAll('.Model3d')

  if (model3dItems) {
    Array.prototype.forEach.call(model3dItems, function (model3dItem) {
      window.hideAnnotations(
        model3dItem.querySelector('.hide-annotations-button'),
      )

      window.setCamera(
        model3dItem.querySelector('model-viewer'),
        model3dItem.querySelector('model-viewer').getAttribute('camera-orbit'),
      )
    })
  }
}

function fragmentShownEvent(event) {
  const fragment = event.fragment

  if (fragment.getAttribute('data-attribute-action') == 'playVideo') {
    const currentSlideVideo = deck.getCurrentSlide().querySelector('video')

    const currentSlideCompositeVideoTitle = deck
      .getCurrentSlide()
      .querySelector('.PresentationSlideCompositeMedia-title')

    if (currentSlideCompositeVideoTitle != undefined) {
      currentSlideCompositeVideoTitle.hidden = true
    }

    if (currentSlideVideo != undefined) {
      currentSlideVideo.plyr.play()
    }
  }
}

function fragmentHiddenEvent(event) {
  const fragment = event.fragment

  if (fragment.getAttribute('data-attribute-action') == 'playVideo') {
    const currentSlideVideo = deck.getCurrentSlide().querySelector('video')

    const currentSlideCompositeVideoTitle = deck
      .getCurrentSlide()
      .querySelector('.PresentationSlideCompositeMedia-title')

    if (currentSlideCompositeVideoTitle != undefined) {
      currentSlideCompositeVideoTitle.hidden = false
    }

    if (currentSlideVideo != undefined) {
      currentSlideVideo.plyr.pause()
    }
  }
}

if (PresentationElements.length > 0) {
  ;(async () => {
    const { default: Reveal } = await import('reveal.js')
    await import('reveal.js/dist/reveal.css')
    const { default: RevealNotes } = await import(
      'reveal.js/plugin/notes/notes.esm.js'
    )

    deck = new Reveal({
      plugins: [RevealNotes],
    })

    deck.configure({
      keyboard: {
        33: 'prev',
        34: 'next',
      },
    })

    deck.initialize({
      width: '100%',
      height: '100%',
      margin: 0,
      minScale: 1,
      maxScale: 1,
      transition: 'fade',
    })

    deck.on('ready', presentationSlideInit)
    deck.on('slidechanged', presentationSlideInit)
    deck.on('fragmentshown', fragmentShownEvent)
    deck.on('fragmenthidden', fragmentHiddenEvent)
  })()
}

Array.prototype.forEach.call(
  PresentationElements,
  function (presentationElement) {
    presentationElement.addEventListener('mousemove', () => {
      addPresentationActiveClass(presentationElement)
    })

    PresentationThemeSwitch.addEventListener('click', () => {
      if (presentationElement.classList.contains('Presentation--themeDark')) {
        PresentationThemeSwitch.setAttribute('aria-pressed', false)
      } else {
        PresentationThemeSwitch.setAttribute('aria-pressed', true)
      }

      presentationElement.classList.toggle('Presentation--themeDark')
    })
  },
)

const presentationLogo = document.querySelector('.Presentation-logo')
const presentationTitle = document.querySelector('.Presentation-title')

function updatePresentationSpacing() {
  if (presentationLogo) {
    document.documentElement.style.setProperty(
      '--presentation-content-bottom-spacing',
      presentationLogo.offsetHeight + 'px',
    )
  }

  if (presentationTitle) {
    document.documentElement.style.setProperty(
      '--presentation-content-top-spacing',
      presentationTitle.offsetHeight + 'px',
    )
  }
}

updatePresentationSpacing()

addEventListener('resize', updatePresentationSpacing())
